import { createContext } from 'react';
import { settings } from 'AppConfig';
export const AppConfigContext = createContext(settings);

